import { render } from "./PolicyForm.vue?vue&type=template&id=0fd362d3&scoped=true"
import script from "./PolicyForm.vue?vue&type=script&lang=js"
export * from "./PolicyForm.vue?vue&type=script&lang=js"

import "./PolicyForm.vue?vue&type=style&index=0&id=0fd362d3&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd362d3"]])

export default __exports__